import { render, staticRenderFns } from "./StoriesArticleAudioPlayerMain.vue?vue&type=template&id=3d6fa056&scoped=true&"
import script from "./StoriesArticleAudioPlayerMain.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleAudioPlayerMain.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleAudioPlayerMain.vue?vue&type=style&index=0&id=3d6fa056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6fa056",
  null
  
)

export default component.exports